module.exports = function(arg, context) {
  var called, fnIn, fnOut, old;
  fnOut = arg.out, fnIn = arg["in"];
  called = false;
  old = void 0;
  return this.subscribe(function(val) {
    if (called) {
      fnOut.call(this, old);
    }
    fnIn.call(this, val);
    old = val;
    called = true;
  }, context);
};
